import React from 'react'
import { useStyles } from './styles'
import take from 'lodash/take'
import orderBy from 'lodash/orderBy'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { ArgumentScale, ValueScale } from '@devexpress/dx-react-chart'
import { scaleBand } from '@devexpress/dx-chart-core'
import { ArgumentAxis, ValueAxis, Chart, BarSeries, Title } from '@devexpress/dx-react-chart-material-ui'
import Bar from './components/Bar'
import TitleText from './components/TitleText'
import ArgumentAxisLegend from './components/ArgumentAxisLegend'
import ValueAxisLegend from './components/ValueAxisLegend'
import Export from './components/Export'
import { ROOT_CONTAINER_ID } from '../../../../utils/graphUtils'

const StoriesGraph = ({ data: { tags } }) => {
  const classes = useStyles()
  const chartData = orderBy(take(tags.top, 10), 'name')
  return (
    <Grid container item xs={12} alignItems='center' justifyContent='space-between'>
      <Paper className={classes.chartBackground} id={ROOT_CONTAINER_ID}>
        <Chart data={chartData} className={classes.chart}>
          <ArgumentScale factory={scaleBand} />
          <ArgumentAxis
            showTicks={false}
            indentFromAxis={16}
            labelComponent={props => {
              const [firstWord, secondWord, thirdWord] = props.text.replace('-', ' - ').split(' ')
              return (
                <>
                  <ArgumentAxis.Label
                    {...props}
                    y={props.y - 5}
                    style={{
                      fill: '#000000',
                      fontFamily: 'National',
                      fontSize: 10,
                      fontWeight: 'bold'
                    }}
                    text={firstWord}
                  />
                  {secondWord ? (
                    <ArgumentAxis.Label
                      {...props}
                      y={props.y + 10}
                      style={{
                        fill: '#000000',
                        fontFamily: 'National',
                        fontSize: 10,
                        fontWeight: 'bold'
                      }}
                      text={secondWord}
                    />
                  ) : null}
                  {thirdWord ? (
                    <ArgumentAxis.Label
                      {...props}
                      y={props.y + 25}
                      style={{
                        fill: '#000000',
                        fontFamily: 'National',
                        fontSize: 10,
                        fontWeight: 'bold'
                      }}
                      text={thirdWord}
                    />
                  ) : null}
                </>
              )
            }}
          />
          <ValueScale modifyDomain={([min, max]) => [min, max ? max * 1.25 : 1]} />
          <ValueAxis showGrid={false} showLine={true} tickFormat={() => tick => Number.isInteger(tick) ? tick : null} />
          <Title text='Stories by Tag' textComponent={TitleText} />
          <BarSeries valueField='usageCount' argumentField='name' pointComponent={Bar} barWidth={0.7} />
          <ArgumentAxisLegend />
          <ValueAxisLegend />
          <Export />
        </Chart>
      </Paper>
    </Grid>
  )
}

export default StoriesGraph
